/* eslint-disable @typescript-eslint/no-explicit-any */
import { NgClass } from '@angular/common';
import { Component, computed, inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Auth } from '@core/services/auth';
import { Theme } from '@core/services/theme';
import { AppConfirmDialog } from '@shared/components/confirm-dialog/confirm-dialog';
import { AuthSidebar } from '@shared/components/navigation/components/auth-navbar/auth-sidebar';
import { ToastModule } from 'primeng/toast';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule, AuthSidebar, NgClass, AppConfirmDialog],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  private auth = inject(Auth);
  private theme = inject(Theme);
  private router = inject(Router);

  currentRoute = signal('');
  excludedRoutes = ['/welcome', '/login', '/forgot-password'];

  toastBreakpoints = signal({
    '920px': { width: '95%', right: '0', left: '0', 'margin-inline': 'auto' },
  });

  isAuth = computed(() => this.auth.isAuth());

  ngOnInit() {
    // Verificar sesión inicial
    this.auth.getSession();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentRoute.set(event.url);
      });
  }
}
